// src/registry/index.ts
var registry = /* @__PURE__ */ new Map();
function registerWidget(def) {
  registry.set(def.type, def);
}
function getWidget(type) {
  return registry.get(type);
}
function getAllWidgets() {
  return Array.from(registry.values());
}
function hasWidget(type) {
  return registry.has(type);
}

export {
  registerWidget,
  getWidget,
  getAllWidgets,
  hasWidget
};
//# sourceMappingURL=chunk-E2OTEEMV.js.map